import P5vue from './index.vue';

export default P5vue;